// Generated from FantasyFootballCalculator ADP PPR for 12-team, 2025 season
// Source: https://fantasyfootballcalculator.com/api/v1/adp/ppr?teams=12&year=2025
// To refresh: replace the JSON file and the mapping will update on next build

import raw from './adp_ppr_2025_12.json';

// Sort by ADP ascending and take top 204 overall picks
const sorted = [...(raw?.players || [])].sort((a, b) => a.adp - b.adp);

export const ADP_TOP_204 = sorted.slice(0, 204).map((p, idx) => ({
  overall: idx + 1,
  name: p.name,
  position: p.position,
  team: p.team,
  adp: p.adp,
  adp_formatted: p.adp_formatted,
  bye: p.bye,
}));

// Convenience lookup by overall number (1-based)
export const ADP_BY_OVERALL = new Map(ADP_TOP_204.map((p) => [p.overall, p]));



